import ItemPasteFile from './ItemPasteFile';

export default ItemPasteFile;
